export const MONK_V3 = 'monk-v3';
export const COCKPIT_V3 = 'cockpit-v3';
export const SURFACE_V3 = 'surface-v3';
export const AUTH_V3 = 'auth-v3';
export const UTILITY_V3 = 'utility-v3';
export const API_URL = process.env.REACT_APP_API_URL;
export const MEDIA_LINK = process.env.REACT_APP_MEDIA_LINK;
